import { createRouter, createWebHistory } from 'vue-router'
import PluginView from '@/views/PluginView.vue'
import NotFound from '@/views/NotFound.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:facilitySlug/obchodne-podmienky',
      name: 'legal-terms',
      component: () => import('@/views/LegalPageView.vue'),
      props: route => ({
        facilitySlug: String(route.params.facilitySlug),
        kind: 'terms' as const,
      }),
    },
    {
      path: '/:facilitySlug/suhlas-so-spracovanim-osobnych-udajov',
      name: 'legal-privacy',
      component: () => import('@/views/LegalPageView.vue'),
      props: route => ({
        facilitySlug: String(route.params.facilitySlug),
        kind: 'privacy' as const,
      }),
    },
    {
      path: '/:facilitySlug?',
      name: 'plugin',
      component: PluginView,
      props: true,
      beforeEnter(to, _from, next) {
        if (to.path !== '/' || !to.query.facility_slug || !to.query.reservation_id) {
          next()
          return
        }
        next({
          path: `/${to.query.facility_slug}`,
          query: to.query,
          replace: true,
        })
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFound,
    },
  ],
})

export default router
